import { RootContext } from "./chunk-CFH6T5NP.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Icon/Icon.tsx
import { forwardRef, useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var ICON_CLASSNAME_MAP = {
  size: {
    "em": "pd-icon--em",
    "sm": "pd-icon--sm",
    "md": "",
    "lg": "pd-icon--lg",
    "xl": "pd-icon--xl",
    "2xl": "pd-icon--2xl"
  }
};
var Icon = forwardRef((_a, ref) => {
  var _b = _a,
    {
      icon,
      size = "md",
      className
    } = _b,
    properties = __objRest(_b, ["icon", "size", "className"]);
  const {
    iconSpritePath
  } = useContext(RootContext);
  return /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
    ref,
    className: clsx("pd-icon", ICON_CLASSNAME_MAP.size[size], className),
    role: "img",
    "aria-hidden": "true"
  }, properties), {
    children: /* @__PURE__ */jsx("use", {
      xlinkHref: "".concat(iconSpritePath != null ? iconSpritePath : "", "#").concat(icon)
    })
  }));
});
var StoryIcon = properties => /* @__PURE__ */jsx(Icon, __spreadValues({}, properties));
var Icon_default = Icon;
export { ICON_CLASSNAME_MAP, StoryIcon, Icon_default };